// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/flight-plan-filing-limits.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/flight-plan-filing-limits/flight-plan-filing-limits.js';
import g1 from '../lessons/air-law/flight-plan-filing-limits/flight-plan-filing-steps.js';
import g2 from '../lessons/air-law/flight-plan-filing-limits/flight-plan-lead-time.js';
import g3 from '../lessons/air-law/flight-plan-filing-limits/flight-plan-where-to-file.js';

mount([g0, g1, g2, g3]);
